import lazyLoading from './lazyLoading';

export default {
  name: 'Promotions',
  path: '/park/promotions/:id?',
  component: lazyLoading('parkec/PARK_Promotions'),
  meta: {
    title: 'schema.park_promotions',
    iconClass: 'fas fa-certificate',
    to: '/park/promotions',
    auth: 'admin',
  },
  props: r => ({root: true, id: r.params.id}),
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/promotion.js